<template>
    <span class="w-full p-input-icon-right" style="height: 100%">
        <InputText :id="'passwordInputText-'+uid" class="w-full pr-5" ref="passwordText" v-model="valCopy" :placeholder="placeholder" :class="{'p-invalid': isInvalid}" :autocomplete="autocomplete" :name="name" :type="showPassword ? 'text' : type"/>
        <i @click="showPassword = !showPassword" style="opacity: 0.65" class="flex flex-row align-items-center">
            <SvgEyeSlash v-if="showPassword" className="inputcomponent-right-svg" color="var(--theme-font-color)"/>
            <SvgEye v-else className="inputcomponent-right-svg" color="var(--theme-font-color)"/>
        </i>
    </span>
</template>

<script setup>
// --- IMPORTS ---
import { onMounted, ref, toRefs, watchEffect } from "vue"
// PrimeVue
import InputText from 'primevue/inputtext'
// vue
import SvgEye from '@/components/SVGs/SvgEye.vue'
import SvgEyeSlash from '@/components/SVGs/SvgEyeSlash.vue'

// --- PROPS ---
const props = defineProps({
    val: String,
    placeholder: String,
    isInvalid: Boolean,
    focusWhenMounted: {
        type: Boolean,
        default: false
    },
    uid: String,
    type: {
        type: String,
        default: "password"
    },
    name: {
        type: String,
        default: "password"
    },
    autocomplete: {
        type: String,
        default: "current-password"
    },
})
const { val, focusWhenMounted } = toRefs(props)

// --- EMITS ---
const emit = defineEmits(['update-val'])

// --- Value ---
const valCopy = ref(val.value)
watchEffect(() => {
    valCopy.value = val.value
})

watchEffect(() => {
    emit('update-val', valCopy.value)
})

// --- Focus onMounted ---
const passwordText = ref(null)
onMounted(() => {
    if (focusWhenMounted.value) { passwordText.value.$el.focus() }
})

// --- Show/Hide password ---
const showPassword = ref(false)
</script>

<style scoped>
:deep(.pi) {
    color: var(--theme-font-color);
    opacity: 0.65;
}
:deep(.input div) {
    width: 10%;
}
</style>